import { LiksButton } from '../../components/liks/LiksButton/LiksButton';
import { LiksDialog } from '../../components/liks/LiksDialog/LiksDialog';
import '../knowledge/CreateKnowledgeDatabaseDialog.css';
import './CreateTrainingExampleDialog.css';

type ChatbotConversationTrainingSourceStatusDialogProps = {
  title: string;
  message: string;
  questionSnapshot?: string;
  closeLabel: string;
  onClose: () => void;
};

export function ChatbotConversationTrainingSourceStatusDialog({
  title,
  message,
  questionSnapshot,
  closeLabel,
  onClose,
}: ChatbotConversationTrainingSourceStatusDialogProps) {
  return (
    <LiksDialog
      isOpen
      size="md"
      title={title}
      onClose={onClose}
      closeLabel={closeLabel}
      footer={
        <LiksButton type="button" variant="secondary" onClick={onClose}>
          {closeLabel}
        </LiksButton>
      }
    >
      <p className="liks-knowledge-create__hint">{message}</p>
      {questionSnapshot != null && questionSnapshot.trim() !== '' && (
        <div className="create-training-dialog__notice" role="note">
          <p className="create-training-dialog__notice-title">
            {questionSnapshot}
          </p>
        </div>
      )}
    </LiksDialog>
  );
}
